import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton'

import commentActions from 'actions/commentActions'
import commentWizard from 'actions/commentWizard'

export class AddButton extends Component{
	render(){
		let { props } = this
		return(
			<RaisedButton
				label="SEND US A MESSAGE"
				icon={<i className="material-icons" style={{color: "#FFF"}}>comment</i>}
				backgroundColor="#009688"
				style={{margin: "0px", float:"right"}}
				labelColor="#FFF"
				onClick={()=>{if (props.commentWizard) {props.COMMENT_ADD(); props.COMMENTWIZARD_SHOW();} else props.COMMENT_ADD()}}
			/>
		)
	}
}
export default connect(null, R.mergeAll([commentActions, commentWizard]))(AddButton)



// WEBPACK FOOTER //
// ./src/components/Communication/AddButton.js